import React, { ReactNode, useRef, useState } from "react";

import { Tooltip } from "components";

/*
Remember to set:
.tooltip-span {
    display: unset;
    .className {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
*/

export const OverflowEllipsisWithTooltip = ({
  children,
  className = "",
  title,
  verticalOverflow = false,
}: {
  children: ReactNode;
  className?: string;
  title: string;
  verticalOverflow?: boolean;
}) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  // measured when the tooltip is about to show, so the size of that moment counts: popups and hover layouts settle after mounting
  const handleOpenChange = (wantsToOpen: boolean) => {
    const el = spanRef.current;
    const overflowed = !!el && (verticalOverflow ? el.scrollHeight > el.clientHeight : el.scrollWidth > el.clientWidth);
    setOpen(wantsToOpen && overflowed);
  };

  return (
    <Tooltip title={title} open={open} onOpenChange={handleOpenChange} className={`tooltip-span ${className}`}>
      <span ref={spanRef} className={className}>
        {children}
      </span>
    </Tooltip>
  );
};

export default OverflowEllipsisWithTooltip;
